var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisuClimateDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 235,
    viewBox: "0 0 454 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 453.59,
    height: 234.882,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284.59,
    height: 224,
    transform: "translate(0 10.8818)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 198.882H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 166.882H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 134.882H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 102.882H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 70.8818H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 38.8818H284.59",
    stroke: "#EDF2F7",
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 101.239C22 101.239 52.5013 191.771 83.3342 191.771C114.167 191.771 114.167 193.52 145 193.52C175.501 193.52 175.501 120.92 206.334 120.92C237.167 120.92 268 32.1372 268 32.1372",
    stroke: "#F6AD55",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 122.669C22 122.669 52.5013 104.738 83.3342 104.738C114.167 104.738 114.167 75.4351 145 75.4351C175.501 75.4351 175.501 84.6195 206.334 84.6195C237.167 84.6195 268 117.421 268 117.421",
    stroke: "#4FD1C5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10.8818C17 10.8818 52.5013 137.796 83.3342 137.796C114.167 137.796 114.167 195.882 145 195.882C175.501 195.882 175.501 194.122 206.334 194.122C237.167 194.122 268 84.5508 268 84.5508",
    stroke: "#7F9CF5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.795,
    cy: 226.882,
    r: 8,
    fill: "#7F9CF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.795,
    y: 223.382,
    width: 64,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.795,
    cy: 226.882,
    r: 8,
    fill: "#4FD1C5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.795,
    y: 223.382,
    width: 52,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.795,
    cy: 226.882,
    r: 8,
    fill: "#F6AD55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.795,
    y: 223.382,
    width: 19,
    height: 7,
    rx: 3.5,
    fill: "#E2E8F0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 92,
    transform: "translate(304.59)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.84 9.68421C323.215 9.68421 304.59 85.0827 304.59 85.0827V92H453.59V28.8221C453.59 28.8221 434.965 0 416.34 0C397.715 0 397.715 30.6667 379.09 30.6667C360.465 30.6667 360.465 9.68421 341.84 9.68421Z",
    fill: "#81E6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.84 12.2417C323.215 12.2417 304.59 49.6933 304.59 49.6933V91.9998H453.59V67.032C453.59 67.032 434.965 42.0643 416.34 42.0643C397.715 42.0643 397.715 49.6933 379.09 49.6933C360.465 49.6933 360.465 12.2417 341.84 12.2417Z",
    fill: "#A3BFFA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333.359 124H312.927C308.509 124 304.927 127.582 304.927 132V140.783C304.927 145.201 308.509 148.783 312.927 148.783H333.359C337.777 148.783 341.359 145.201 341.359 140.783V132C341.359 127.582 337.777 124 333.359 124Z",
    fill: "#A3BFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.309 124H368.877C364.459 124 360.877 127.582 360.877 132V140.783C360.877 145.201 364.459 148.783 368.877 148.783H389.309C393.727 148.783 397.309 145.201 397.309 140.783V132C397.309 127.582 393.727 124 389.309 124Z",
    fill: "#A3BFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.253 124H424.821C420.403 124 416.821 127.582 416.821 132V140.783C416.821 145.201 420.403 148.783 424.821 148.783H445.253C449.671 148.783 453.253 145.201 453.253 140.783V132C453.253 127.582 449.671 124 445.253 124Z",
    fill: "#81E6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.359 167.049H312.927C308.509 167.049 304.927 170.631 304.927 175.049V183.832C304.927 188.251 308.509 191.832 312.927 191.832H333.359C337.777 191.832 341.359 188.251 341.359 183.832V175.049C341.359 170.631 337.777 167.049 333.359 167.049Z",
    fill: "#A3BFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.309 167.049H368.877C364.459 167.049 360.877 170.631 360.877 175.049V183.832C360.877 188.251 364.459 191.832 368.877 191.832H389.309C393.727 191.832 397.309 188.251 397.309 183.832V175.049C397.309 170.631 393.727 167.049 389.309 167.049Z",
    fill: "#C3DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.253 167.049H424.821C420.403 167.049 416.821 170.631 416.821 175.049V183.832C416.821 188.251 420.403 191.832 424.821 191.832H445.253C449.671 191.832 453.253 188.251 453.253 183.832V175.049C453.253 170.631 449.671 167.049 445.253 167.049Z",
    fill: "#81E6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.359 210.099H312.927C308.509 210.099 304.927 213.68 304.927 218.099V226.882C304.927 231.3 308.509 234.882 312.927 234.882H333.359C337.777 234.882 341.359 231.3 341.359 226.882V218.099C341.359 213.68 337.777 210.099 333.359 210.099Z",
    fill: "#C3DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.309 210.099H368.877C364.459 210.099 360.877 213.68 360.877 218.099V226.882C360.877 231.3 364.459 234.882 368.877 234.882H389.309C393.727 234.882 397.309 231.3 397.309 226.882V218.099C397.309 213.68 393.727 210.099 389.309 210.099Z",
    fill: "#81E6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.253 210.099H424.821C420.403 210.099 416.821 213.68 416.821 218.099V226.882C416.821 231.3 420.403 234.882 424.821 234.882H445.253C449.671 234.882 453.253 231.3 453.253 226.882V218.099C453.253 213.68 449.671 210.099 445.253 210.099Z",
    fill: "#B2F5EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 453.59,
    height: 234.882,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 284.59,
    height: 224,
    fill: "white",
    transform: "translate(0 10.8818)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 245,
    height: 16,
    fill: "white",
    transform: "translate(19.795 218.882)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 92,
    fill: "white",
    transform: "translate(304.59)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisuClimateDesktop);
export default __webpack_public_path__ + "static/media/visu_climate_desktop.0e70c9707e240ef4d2b1757367e0804a.svg";
export { ForwardRef as ReactComponent };